/**
 * G2eGente - Wrapper que bloqueia acesso web para candidatos
 * Redireciona para /app se não estiver acessando via PWA instalado
 */
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';

export default function MobileOnlyRoute({ children }) {
  const [isChecking, setIsChecking] = useState(true);
  const [shouldRedirect, setShouldRedirect] = useState(false);

  useEffect(() => {
    // Detecta se está rodando como PWA (standalone) ou no navegador
    const isStandalone = window.matchMedia('(display-mode: standalone)').matches 
      || window.navigator.standalone === true  // iOS
      || document.referrer.includes('android-app://'); // Android TWA
    
    // Detecta se é mobile
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    
    // Detecta se está na rota mobile (/m/...)
    const isMobileRoute = window.location.pathname.startsWith('/m/') || window.location.pathname === '/m';
    
    // Se não é standalone E não está na rota mobile E é mobile device
    // Então redireciona para instalar o app
    if (!isStandalone && !isMobileRoute && isMobile) {
      setShouldRedirect(true);
    }
    
    // Se é desktop, também redireciona (candidatos devem usar apenas mobile)
    if (!isMobile) {
      setShouldRedirect(true);
    }
    
    setIsChecking(false);
  }, []);

  if (isChecking) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-900">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-cyan-500"></div>
      </div>
    );
  }

  if (shouldRedirect) {
    return <Navigate to="/app" replace />;
  }

  return children;
}
